import React from 'react';

interface IProps {
	children: React.ReactNode;
	testId: string;
}

export const ListingControlPanel: React.FC<IProps> = ({ children, testId }) => (
	<div className="flex flex-col gap-4" data-test={testId}>
		{children}
	</div>
);
